import axiosInstance from "../Pages/configuration/Request";

const addNonEmptyFields = (target, fields) => {
  Object.entries(fields).forEach(([key, value]) => {
    if (value !== "" && value !== undefined) {
      target[key] = isNaN(value) ? value : Number(value);
    }
  });
};

export const handleTumorigenesis = (data) => {
  const tumorigenesisData = {};
  addNonEmptyFields(tumorigenesisData, {
    FDR: data?.fdr,
    logFC_TvN: data?.fold_change,
    paired: data?.isParied,
  });
  if (tumorigenesisData.logFC_TvN !== undefined) {
    tumorigenesisData.FC_threshold = data?.fc_threshold;
  }
  return tumorigenesisData
}

export const handleSurvival = (data) => {
  const survivalData = {};
  addNonEmptyFields(survivalData, {
    HR: data?.hazard_ratio,
  });
  if (survivalData.HR !== undefined) {
    survivalData.HR_threshold = data?.hr_threshold;
  }
  return survivalData
}

export const handleProliferation = (data) => {
  const proliferationData = {};
  addNonEmptyFields(proliferationData, {
    sig_percent_CRISPR: data?.sig_percent_crispr,
    sig_percent_RNAi: data?.sig_percent_rnai,
  });
  if (
    proliferationData.sig_percent_CRISPR !== undefined &&
    proliferationData.sig_percent_RNAi !== undefined
  ) {
    proliferationData.sig_condition = data?.sig_condition;
  }
  return proliferationData
}


export const fetchTableData = async (operationDetails, page, limit, type = "") => {
  const tableData = operationDetails.viewDetails[operationDetails.type]
  let payload = {
    data: {
      network_id: operationDetails?.networkId || null,
      cancer_type: operationDetails?.cancerType || null,
      histological_subtype: operationDetails?.histological_subtype || null,
      page: page,
      pageSize: limit,
      ...(type === "result" && { cmap: "true" })
    },
  };

  switch (operationDetails.type) {
    case "Tumorigenesis":
      payload.data.tumorigenesis = handleTumorigenesis(tableData);
      break;

    case "Survival":
      payload.data.survival = handleSurvival(tableData);
      break;

    case "Proliferation":
      payload.data.proliferation = handleProliferation(tableData);
      break;

    case "Drug_Sensitivity":
      payload.data.drug_sensitivity = true;
      break;
    case "Significant_Condition":
      if (operationDetails.viewDetails.Tumorigenesis.selected) {
        payload.data.tumorigenesis = handleTumorigenesis(operationDetails.viewDetails.Tumorigenesis);
      }
      if (operationDetails.viewDetails.Survival.selected) {
        payload.data.survival = handleSurvival(operationDetails.viewDetails.Survival);
      }
      if (operationDetails.viewDetails.Proliferation.selected) {
        payload.data.proliferation = handleProliferation(operationDetails.viewDetails.Proliferation);
      }
      if (operationDetails.viewDetails.Drug_Sensitivity.selected) {
        payload.data.drug_sensitivity = true;
      }
      payload.data.significant_type = operationDetails.significantCondition;
      break;
    case "Centrality":
      payload.data.centrality_type = operationDetails?.centrality;
      if (operationDetails?.top_percentage !== "") {
        payload.data.centrality_percentage = operationDetails.top_percentage;
      }
      break;
    case "Pathway":
      payload.data.pathways = operationDetails?.pathway;
      break;

    default:
      console.log("Unknown viewType:", operationDetails.type);
  }

  // Add source_type to data payload for Projects
  if (operationDetails.isFromProject) {
    payload.data.source_type = "gene-list";
  }

  const formData = new FormData();
  formData.append("data", JSON.stringify(payload.data));

  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BASE_URL}api/further-analysis`,
      formData
    );
    return response?.data;
  } catch (error) {
    console.log("Error fetching data:", error);
    return null;
  }
};

export const fetchTableDataAllDownload = async (operationDetails, imageBlob) => {
  let data = {
    download: true,
    network_id: operationDetails?.networkId || null,
    cancer_type: operationDetails?.cancerType || null,
    histological_subtype: operationDetails?.histological_subtype || null,
    cmap: "true"
  }


  Object.keys(operationDetails.viewDetails).forEach((key) => {
    const option = operationDetails.viewDetails[key];
    if (option.selected) {
      switch (key) {
        case "Tumorigenesis":
          data.tumorigenesis = handleTumorigenesis(option);
          break;
        case "Survival":
          data.survival = handleSurvival(option);
          break;
        case "Proliferation":
          data.proliferation = handleProliferation(option);
          break;
        case "Drug_Sensitivity":
          data.drug_sensitivity = true;
          break;
        default:
          console.log("Unknown option:", key);
      }
    }
  });

  if (operationDetails.significantCondition) {
    data.significant_type = operationDetails.significantCondition;
  }
  if (operationDetails.centrality) {
    data.centrality_type = operationDetails.centrality;
    if (operationDetails?.top_percentage !== "") {
      data.centrality_percentage = operationDetails.top_percentage;
    }
  }
  if (operationDetails.pathway) {
    data.pathways = operationDetails.pathway;
  }

  // Add source_type to data payload for Projects
  if (operationDetails.isFromProject) {
    data.source_type = "gene-list";
  }

  const formData = new FormData();

  // Only append image for Networks, not for Projects
  if (!operationDetails.isFromProject && imageBlob) {
    formData.append("image", imageBlob);
  }

  formData.append("data", JSON.stringify(data));

  try {
    const response = await axiosInstance.post(
      `${process.env.REACT_APP_BASE_URL}api/further-analysis`,
      formData,
      {
        responseType: 'blob', // Ensure the response is treated as a Blob
      }
    );

    if (!response.data) {
      throw new Error("No data received from the server");
    }

    return response.data; // Return the Blob
  } catch (error) {
    console.error("Error fetching data:", error);
    throw error;
  }
};
